module.exports = __webpack_public_path__ + "static/media/circle_black.01f18836.svg";